<template>
  <div>
    <v-card class="card">
      <v-card-title
        >Одбери јазик <br />
        Choose a language <br />
        Zgjidhni një gjuhë
      </v-card-title>
      <v-card-actions class="justify-center">
        <v-btn class="button" @click="toggleLanguage('mk')"
          ><img :src="require('../assets/mkflag.svg')" alt="MK"
        /></v-btn>
        <v-btn class="button" @click="toggleLanguage('en')"
          ><img :src="require('../assets/ukflag.svg')" alt="EN"
        /></v-btn>
        <v-btn class="button" @click="toggleLanguage('al')"
          ><img :src="require('../assets/alflag.svg')" alt="AL"
        /></v-btn>
      </v-card-actions>
    </v-card>
  </div>
</template>

<script>
export default {
  methods: {
    toggleLanguage(lang) {
      this.$emit("toggle-language", lang);
    },
  },
};
</script>

<style scoped>
img {
  max-width: 30px;
}
.card {
  border-radius: 12px;
  box-shadow: 0 1px 10px rgba(0, 0, 0, 0.99);
  padding: 0.1rem;
  margin: 2rem auto;
  max-width: 18rem;
  text-align: center;
}
.button {
  background-color: bisque;
  color: white;
  max-width: 20px;
}
</style>
